import { useInfiniteQuery } from '@tanstack/react-query';
import { contentApi, folderApi, IContentListResponse, TContentListOrder } from '@_entities/content';
import { get } from '@_shared/config';
import { CONTENT_QUERY_KEYS } from '../../model';

export function useContentListQuery(folderId: string, order: TContentListOrder, keyword: string) {
	const { data, isLoading, isError, fetchNextPage, hasNextPage, isFetchingNextPage, error } =
		useInfiniteQuery<IContentListResponse>({
			queryKey: CONTENT_QUERY_KEYS.contentList(folderId, order, keyword),
			queryFn: async ({ pageParam }) => {
				const requestFolderId = folderId === 'all' ? undefined : folderId;

				if (typeof pageParam === 'string') {
					// 다음 페이지 요청
					const response = await get<IContentListResponse>(pageParam);
					return response.data;
				}

				if (keyword !== '') {
					// 검색 결과 요청
					const response = await contentApi.search(keyword, order, requestFolderId);
					return response.data;
				}

				// 첫 페이지 요청
				const response = await folderApi.getContentListByFolder(requestFolderId, order);
				return response.data;
			},
			getNextPageParam: (lastPage) => lastPage.next || undefined,
			initialPageParam: null,
		});

	return {
		data:
			data === undefined
				? undefined
				: {
						next: data.pages[data.pages.length - 1].next,
						count: data.pages[0].count,
						contentData: data.pages.flatMap((page) => page.contentData),
						pinnedData: data.pages.flatMap((page) => page.pinnedData),
					},
		isLoading,
		error,
		isError,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage,
	};
}
